import mediator from './mediator.png'

const content = `<p>The Mediator design pattern consists in introducing an object that centralizes the logic of interactions between a set of other objects.</p>

<p>A classic example is for UI code where an action on an element should trigger reactions on other elements.</p>

<p>One way to implement this is to have each element notify the other elements that need to react. But this creates dense coupling, as all the elements have to know about one another.</p>

<p>By introducing a central object, the Mediator, each element can notify the Mediator, and it’s the Mediator that contains all the code that knows which element should react to which event.</p>

<p>This way each element is connected only to the Mediator, and not to the other elements.</p>

<img src=${mediator} alt="mediator" />

<p>Seen this way, Mediator is a way to achieve the design principle of <a href="/indirection"><strong>Indirection</strong></a>.</p>`

export default content
